import { PaletteColor, PaletteColorOptions, createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    foreColor: PaletteColor;
    backColor: PaletteColor;
  }
  interface PaletteOptions {
    foreColor?: PaletteColorOptions;
    backColor?: PaletteColorOptions;
  }

  // Extending PaletteColorOptions and PaletteColor to include medium
  interface PaletteColorOptions {
    light?: string;
    mediumLight?: string;
    main?: string;
    mediumDark?: string;
    dark?: string;
    error?: string;
    success?: string;
    blue?: string;
    holiday?: string;
    caution?: string;
  }

  interface PaletteColor {
    light: string;
    mediumLight: string;
    main: string;
    mediumDark: string;
    dark: string;
    error: string;
    success: string;
    blue: string;
    holiday: string;
    caution: string;
  }
}

export const theme = createTheme({
  typography: {
    // fontFamily: '"Barlow Condensed", sans-serif',
    fontFamily: "Noto Sans JP, sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  palette: {
    foreColor: {
      light: "#95d1ea",
      main: "#1c82cf",
      dark: "#17394b",
      success: "#22C55E",
      error: "#EF4444",
      blue: "#0909c0",
      holiday: "#feaac9",
      caution: "#EC407A",
    },
    backColor: {
      light: "#FFF",
      main: "#F0F2F5",
      mediumDark: "#17394b",
      dark: "#071e2b",
      caution: "#EC407A",
    },
  },
});
